import Alert from '@mui/material/Alert'
import { useFormikContext, FormikValues } from 'formik'
import { hasFieldConflict, FIELD_CONFLICT_MESSAGE } from './validateFields'

export default function ConflictNotice() {
  const { values, submitCount } = useFormikContext<FormikValues>()

  if (submitCount === 0 || !hasFieldConflict(values)) return null

  return <Alert severity="error" sx={{ mt: 2 }}>{FIELD_CONFLICT_MESSAGE}</Alert>
}
